<script setup lang="ts">
const PROFILES = [
  {
    name: 'Katie',
    description: 'Katie is a reading specialist from Colorado with two Master’s degrees in early literacy. She is also an Orton Gillingham trainer (CALT) and an absolute rockstar.',
    avatarUrl: '/images/homeschool/katie.png',
  },
  {
    name: 'Mary',
    description: 'Mary is an elementary Literacy Coach with a Master’s in early literacy. She helps and trains schools to increase reading scores and student engagement.',
    avatarUrl: '/images/homeschool/mary.png',
  },
  {
    name: 'Sandy',
    description: 'Sandy is a reading specialist with 30 years of experience, a certification in Orton Gillingham instruction, and an undying passion for literacy.',
    avatarUrl: '/images/homeschool/sandy.png',
  },
  {
    name: 'Janell',
    description: 'Janell is a reading specialist from Colorado and a Teacher of the Year award recipient. She’s been with us since the beginning and is a true reading OG.',
    avatarUrl: '/images/homeschool/janell.png',
  },
  {
    name: 'Kendall',
    description: 'Kendall is as sweet as they come with certification in the Science of Reading, LETRS Level 8, and a Master’s in literacy.',
    avatarUrl: '/images/homeschool/kendall.png',
  },
  {
    name: 'Jeremy',
    description: 'Jeremy is a 25-year educator, reading specialist, published researcher and author, and founder of Lyrics2Learn. He loves anything that involves words.',
    avatarUrl: '/images/homeschool/jeremy.png',
  },
  {
    name: 'Leslie',
    description: 'Leslie is a lifelong reading educator training in the Science of Reading with a LETRS Level 8 Certificate.',
    avatarUrl: '/images/homeschool/leslie.png',
  },
  {
    name: 'Saphronia',
    description: 'Saphronia has taught multiple grade levels, has a Master’s in education technology, and is a literacy guru. She loves baseball, baking, and crafting.',
    avatarUrl: '/images/homeschool/saphronia.png',
  },
];
</script>

<template>
  <div class="tutor-specialists">
    <div v-for="profile in PROFILES" :key="profile.name" class="profile-card">
      <div class="profile-name">{{ profile.name }}</div>
      <img class="profile-image" :src="profile.avatarUrl" :alt="`profile picture for ${profile.name}`">
      <div class="profile-description">{{ profile.description }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "../../sass/theme";

.tutor-specialists {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-width: 20rem;
  max-width: 20rem;
  min-height: 35rem;
  max-height: 35rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 1rem;
}

.profile-card .profile-name {
  font-size: 1.25rem;
  font-weight: bold;
  color: $dark;
}

.profile-card .profile-image {
  max-width: 15rem;
  max-height: 15rem;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}
</style>
